module.exports = __webpack_public_path__ + "static/scale-model-of-world-food-prize-hall-of-laureates-in-des-moines-iowa-62e594757a0cffa37163b155e6ed6771.png";